module.exports = __webpack_public_path__ + "img/work05.ca7af0ed.gif";